import React from 'react';
import ReorderRulesOverviewPane from '../../../../Common/ReorderRules/ReorderRulesOverviewPane';

interface ReferenceDataSettingsReorderRulesPane {}

export default function ReferenceDataSettingsReorderRulesPane({}: ReferenceDataSettingsReorderRulesPane) {
  return <ReorderRulesOverviewPane productMasterDataId={undefined} />;
}
